import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button, Modal, Spinner } from 'react-bootstrap';
import CategoryList from '../AllPosts/CategoryList';
import back from '../../Img/new home.png';
import campraImg from "../../Img/logo.png"
import remove from "../../Img/delete.png";
import edit from "../../Img/edit.png"
import { Link, useNavigate } from 'react-router-dom';
// import AdminImg from '../../Img/usrpict.PNG';
import AdminImg from '../../Img/viewer.png';
import Viewer from '../../Img/viewer.png'
import { toast } from 'react-toastify';
import UserMenu from '../UserMenu';
import TopNavBar from '../TopNavBar';
import SideBar from '../SideBar';
import { API_BASE_URL } from "../../utils/config";
import Papa from 'papaparse';
import { MdDeleteForever } from 'react-icons/md';
import { FaUserEdit } from 'react-icons/fa';
import { MDBDataTable } from 'mdbreact'
import 'mdbreact/dist/css/mdb.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import SideBarNew from '../SideBarNew';
// import 'bootstrap-css-only/css/bootstrap.min.css';


function CreateCatagory() {


    const [collaps, setCollaps] = useState(true);
    const [categoryLoading, setCtegoryLoading] = useState(false)

    const reloadCategoryState = () => {
        if (categoryLoading) {
            setCollaps(false)
        } else {
            setCollaps(true)
        }
    }

    const changeCollapsState = () => {
        if (collaps) {
            setCollaps(false)
        } else {
            setCollaps(true)
        }
    }

    // sample csv code

    return (
        <div>

            <div >

                <div className='row g-0'>
                    <div
                        style={{ width: collaps ? "" : "5vw" }}
                        className={collaps ? 'col-3 sidebarBackground1 sidebarBackground  login-left-main-div-new' : 'col-1 sidebarBackground1 sidebarBackground login-left-main-div-new'}>
                        {/* <!-- Content for the left column goes here --> */}
                        {/* <div className="logo-home others-campra-logo">
            <img src={campraImg} alt="" className='campra-log-img' />

          </div> */}

                        <div>
                            <SideBar collaps={changeCollapsState} categoryLoading={categoryLoading} />
                        </div>

                        {/* <div className="repo landing text-white catagory-main-div ">
           
              <CategoryList />
            </div> */}
                    </div>
                    <div className={collaps ? 'column right-column  col-9' : 'column right-column  col '} style={{ minHeight: "90vh" }}>

                        <div className='w-100'>
                            <TopNavBar />
                        </div>
                        {/* <!-- Content for the right column goes here --> */}

                        <div className='w-100'>
                            <SideBarNew collaps={changeCollapsState} />
                        </div>


                    </div>
                    {/* {alert(loading)} */}
                </div >




            </div>
        </div>
    );
}

export default CreateCatagory;
